import { useQuery, gql } from './graphql-provider';
import { Elm_Enum_Scale_Range, Elm_Enum_Scale_Range_Bool_Exp } from '../../../gen/types';

const RANGES_QUERY = gql`
  query GetRanges($where: elm_enum_scale_range_bool_exp) {
    ranges: elm_enum_scale_range(where: $where) {
      value
      description
    }
  }
`;

export function useQueryRanges({where}: {where: Elm_Enum_Scale_Range_Bool_Exp}) {
  const { loading, error, data } = useQuery<
    {ranges: Array<Elm_Enum_Scale_Range>},
    {where: Elm_Enum_Scale_Range_Bool_Exp}
  >(RANGES_QUERY, {
    variables: {where}
  });

  return {
    data: data ? data.ranges : null,
    error,
    loading,
  };
}
